export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00223.250a842f.png";